import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=5657c076&scoped=true&"
import script from "./ProcessTPBLI.vue?vue&type=script&lang=js&"
export * from "./ProcessTPBLI.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=5657c076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657c076",
  null
  
)

export default component.exports